export const CONFIG_KEY = 'NEWRON_PLATFORM_CONFIG'

const getConfig = (): Config => {
  const newronPlatformConfig = (window as any)[CONFIG_KEY] // This config values comes from host-app script variable NEWRON_PLATFORM_CONFIG

  return {
    ECOSYSTEM_BASEURL: process.env.ECOSYSTEM_BASEURL ?? '/graphql',
    API_PATH: process.env.API_PATH ?? '/cie/graphql',
    API_PREFERENCE_PATH: process.env.API_PREFERENCE_PATH ?? '/preference-filters',
    MFE_CIE_ENABLED: newronPlatformConfig?.MFE_CIE_ENABLED ?? '',
  }
}

// checks if the variables exist in process.env, if not, get it from NEWRON_PLATFORM_CONFIG
export const getValueFromKey = (key: string) => {
  const configEnv = getConfig() as any
  return configEnv[key.replace('REACT_APP_', '')]
}

export const env = (key: string): string => {
  const value = getValueFromKey(key)
  if (!value) {
    throw new Error(`${key} is not set`)
  }
  return value
}

export const envNoError = (key: string): string => {
  const value = getValueFromKey(key)
  if (!value) {
    return ''
  }
  return value
}

export interface Config {
  ECOSYSTEM_BASEURL: string
  API_PATH: string
  API_PREFERENCE_PATH: string
  MFE_CIE_ENABLED: string
}
